export const NUMBER_FORMAT = new Intl.NumberFormat('en-us');
